export enum MissionWindowTab {
  Upload = 'Upload',
  MissionInfo = 'Mission Info',
}
